/**
 * switch文でenumの全てのケースが網羅できているかチェックする関数
 */
export function assertNever(o, message) {
    throw new Error(message);
}
